import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, NavigationExtras, Router, RouterStateSnapshot } from '@angular/router';
import { WebSocketService } from 'app/main/services/webSocket.service';
import { AuthService } from '../services/auth.service';
import { LocalAccountService } from '../services/localAccount.service';
import { STORAGE_KEYS, StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AppGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private localAccountService: LocalAccountService,
    private router: Router,
    private storageService: StorageService,
    private webSocketService: WebSocketService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const loggedIn = this.authService.loggedIn();
    return new Promise<boolean>(async (resolve, reject) => {
      const fromPage = route.queryParams.fromPage;
      const nav = this.router.getCurrentNavigation();
      const data = nav.extras.state;
      if (loggedIn) {
        if (fromPage) {
          if (fromPage === 'studentLogin') {
            if (!this.localAccountService.isStudent()) {
              await this.logout();
            }
            this.saveLastUrlAndRedirect(state.url, fromPage, data);
          } else if (fromPage === 'professorLogin') {
            if (!this.localAccountService.isProfessor()) {
              await this.logout();
            }
            this.saveLastUrlAndRedirect(state.url, fromPage, data);
          } else {
            if (!this.localAccountService.isAdmin() || !this.localAccountService.isOperator()) {
              await this.logout();
            }
            this.saveLastUrlAndRedirect(state.url, fromPage, data);
          }
          // resolve(false);
        } else {
          resolve(true);
        }
      } else {
        this.saveLastUrlAndRedirect(state.url, fromPage, data);
      }
    });
  }

  private saveLastUrlAndRedirect(url: string, fromPage: string, data) {
    this.storageService.set(STORAGE_KEYS.REDIRECT_URL, url);
    let extras: NavigationExtras = {
      state: data
    };
    const extrasString = JSON.stringify(extras);
    this.storageService.set(STORAGE_KEYS.REDIRECT_DATA, extrasString);
    let urlToRedirect = '/public-area/redirect';
    if (fromPage) {
      // extras = {};
      urlToRedirect = urlToRedirect + '?fromPage=' + fromPage;
      // extras.queryParams = { fromPage: fromPage };
    }
    return this.router.navigateByUrl(urlToRedirect);
    // return this.router.navigate([urlToRedirect], extras);
  }

  private async logout() {
    await this.authService.logOut().then(async (res: any) => {
      await this.localAccountService.logout();
      this.webSocketService.closeSocket();
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
    });
  }
}
